<template>
  <el-table-column
    prop="count_per_pack"
    label="Darab / kiszerelés"
    align="right"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.count_per_pack }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'count_per_pack',
};
</script>
